import type { ReactElement, ReactNode } from 'react';

type ErrorBannerProps = {
  readonly children: ReactNode;
  readonly className?: string;
};

export const ErrorBanner = ({
  children,
  className = 'rounded-card p-4',
}: ErrorBannerProps): ReactElement => (
  <div role="alert" className={`bg-danger-subtle text-danger text-sm ${className}`}>
    {children}
  </div>
);
